// services/StudentGroupService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getStudentGroups(params = {}) {
    return api.get(ENDPOINTS.GROUPS.BASE, { params });
}
export function getStudentGroupById(id) {
    return api.get(ENDPOINTS.GROUPS.BY_ID(id));
}
export function createStudentGroup(payload) {
    return api.post(ENDPOINTS.GROUPS.BASE, payload);
}
export function updateStudentGroup(id, payload) {
    return api.patch(ENDPOINTS.GROUPS.BY_ID(id), payload);
}
export function deleteStudentGroup(id) {
    return api.delete(ENDPOINTS.GROUPS.BY_ID(id));
}
export function restoreStudentGroup(id) {
    return api.post(`${ENDPOINTS.GROUPS.BY_ID(id)}/restore`);
}
